import {useSelector} from 'react-redux'
import {
  getIsAnchorHotel,
  getSearchId,
  getSearchParameters
} from 'modules/sapiSearch/selectors'
import {getIsLandingItinerary, getUrlParams} from 'modules/search/selectors'
import {
  augmentBookURIWithSearchParameters,
  getBookURISearchParameters
} from 'utils/offers'

import {useGetSRPSearchFlow} from './useGetSRPSearchFlow'
import {useOtaMode} from './useOtaMode'

interface Props {
  splitBookingOfferUrl: string
  hotelId: string
}

export const useSplitBookingRedirectLink = ({
  splitBookingOfferUrl,
  hotelId
}: Props): string => {
  const urlParams = useSelector(getUrlParams)
  const srpSearchId = useSelector(getSearchId)
  const isAnchorHotel = useSelector(state => getIsAnchorHotel(state, hotelId))
  const searchParameters = useSelector(getSearchParameters)
  // The meta landing token only works for the hotel and dates the user landed on
  const canCarryLandingToken = useSelector(state =>
    getIsLandingItinerary(
      state,
      hotelId,
      searchParameters?.checkIn,
      searchParameters?.checkOut
    )
  )
  const srpSearchFlow = useGetSRPSearchFlow()
  const {isOTAMode: isOta} = useOtaMode()

  try {
    const redirectURL = new URL(splitBookingOfferUrl)

    if (urlParams?.freeCancellation === '1')
      redirectURL.searchParams.append('freeCancellation', '1')
    if (urlParams?.payLater === '1')
      redirectURL.searchParams.append('payLater', '1')
    if (urlParams?.profile)
      redirectURL.searchParams.append('profile', urlParams.profile)
    if (urlParams?.utm_source)
      redirectURL.searchParams.append('utm_source', urlParams.utm_source)
    if (urlParams?.amenities?.length > 0) {
      urlParams.amenities.forEach(i =>
        redirectURL.searchParams.append('amenities', i)
      )
    }
    if (isOta) {
      redirectURL.searchParams.append('ota', '1')
    }
    redirectURL.searchParams.append('srpSearchId', srpSearchId)
    redirectURL.searchParams.append('isAnchor', isAnchorHotel ? '1' : '0')
    redirectURL.searchParams.append('srpSearchFlow', srpSearchFlow)
    return augmentBookURIWithSearchParameters(
      getBookURISearchParameters(searchParameters, canCarryLandingToken),
      redirectURL.toString()
    )
  } catch {
    return splitBookingOfferUrl
  }
}
